import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DepotModel} from "../models/depot.model";

@Injectable({providedIn: 'root'})
export class DepotsHttpService {

  private base_url = `/depots`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getAll(params?: any): Observable<{ cursor: string, list: DepotModel[] }> {
    return this.http
      .get<{ cursor: string, list: DepotModel[] }>(this.base_url, {params});
  }

  getOne(id: string): Observable<DepotModel> {
    return this.http
      .get<DepotModel>(`${this.base_url}/${id}`)
  }

  createOne(depot: DepotModel): Observable<DepotModel> {
    return this.http
      .put<DepotModel>(this.base_url, depot);
  }

  updateOne(id: string, depot: DepotModel): Observable<DepotModel> {
    return this.http
      .post<DepotModel>(`${this.base_url}/${id}`, depot);
  }

  deleteOne(id: string): Observable<DepotModel> {
    return this.http
      .delete<DepotModel>(`${this.base_url}/${id}`);
  }

  addBranchesToDepots(depotIds: string[], branchIds: string[]): Observable<any> {
    return this.http
      .post<DepotModel>(`${this.base_url}`, {depotIds: depotIds, branchIds: branchIds});
  }

}
